import { colors } from '@alixpartners/ui-components';
import styled from 'styled-components';
import {
  CostLabel,
  RightSectionColumn,
  SectionWrapper,
} from '../EnvironmentSetup/EnvironmentSetup.styles';

export const AzureDevOpsSectionWrapper = styled(SectionWrapper)`
  .ap-button-secondary {
    width: 196px;
  }

  ${RightSectionColumn} {
    flex-direction: row;
    justify-content: center;
    align-items: center;
    color: ${colors.grey500};
    flex-grow: unset;

    div:first-child {
      margin-top: 0;
    }
  }

  ${CostLabel} {
    margin-left: 8px;
    min-width: 100px;
  }
`;
